var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"puzzle-content"}},[_c('div',{attrs:{"id":"draw"}},[_c('div',{staticClass:"svg-wrapper",on:{"!click":function($event){$event.preventDefault();}}})])])}
var staticRenderFns = []

export { render, staticRenderFns }